import { BannerRequest, BannerResponse } from '@/services/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { BannerState } from './types';

export const initialState: BannerState = {
  img: '',
  url: '',
};

const sliceName = 'banner';

export const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getBannerRequest: (state, action: PayloadAction<BannerRequest>) => {},
    getBannerError: () => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getBannerSuccess: (state, action: PayloadAction<BannerResponse>) => {
      state.img = action.payload.data;
      state.url = action.payload.url;
    },
  },
  extraReducers: {},
});

export const { actions: actionsBanner } = slice;

export const bannerSelector = (state: RootState) => state.banner;

export default slice.reducer;
